import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import { environment } from '../../../../environments/environment';
import {AccountService} from "../../services";
import {ResourceTypeList} from "../model/resourceTypeList";

@Injectable({ providedIn: 'root' })
export class ResourceTypeService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAll() {
        return this.http.get<ResourceTypeList>(`${environment.apiEndpoint}/v1/resource-types`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }
}
